module.exports = __webpack_public_path__ + "img/bjricheng.ff00e9af.png";